module.exports = __webpack_public_path__ + "static/media/read-more-arrow.148ba7f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/read-more-arrow.svg
// module id = 270
// module chunks = 3